import { useState } from "react";
import { BgColors, Devices } from "../constants";
import { getPublicPath } from "../helpers";
// import { Editor } from "./_Editor";
import { Scene } from "./Scene";
import { DeviceSetting } from "./DeviceSetting";
import { ColorSetting } from "./ColorSetting";
import { ImageSetting } from "./ImageSetting";
import { Checkout } from "./Checkout";

const { WHITE } = BgColors;
const { IPHONE_10 } = Devices;

const App = () => {
  // const canvasRef = useRef(null);

  const [device, setDevice] = useState(IPHONE_10);
  const [image, setImage] = useState(getPublicPath(`images/Podcast.png`));
  const [color, setColor] = useState(WHITE);

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   if (canvasRef.current) {
  //     axios.post('/.netlify/functions/send-email', {
  //       image: canvasRef.current.toDataURL(),
  //     });
  //   }
  // };

  return (
    <main className="fixed w-100 top-0 right-0 bottom-0 left-0 flex flex-col md:flex-row">
      <Scene background={color} device={device} image={image} />
      <div className="w-full md:w-112 bg-white flex-shrink md:flex-shrink-0 overflow-y-scroll">
        <div className="p-16">
          <DeviceSetting
            className="mb-24"
            onChange={setDevice}
            value={device}
          />
          <ImageSetting className="mb-24" onChange={setImage} />
          <ColorSetting className="mb-24" onChange={setColor} value={color} />
          <Checkout />
        </div>
      </div>
    </main>
  );
};

export default App;
